import { AddLarge, Cloud } from '@carbon/icons-react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  Heading,
} from 'vet-bones/design-system/components';

import { useAppDispatch } from 'src/ui/app/hooks';
import {
  PORTAL_ENDPOINTS_ADD_CLOUD,
  PORTAL_ENDPOINTS_ADD_EXISTING,
  PORTAL_ENDPOINTS_HEADING,
} from 'src/ui/constants/testIds';
import { PortalEndpointTable } from 'src/ui/containers/endpoints/PortalEndpointTable';
import { DialogType, openedDialog } from 'src/ui/features/ui';
import * as copy from 'src/ui/templates/copy';

export const PortalEndpoints: React.VFC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleAddExisting = () => {
    dispatch(openedDialog({ type: DialogType.ADD_ENDPOINT }));
  };

  const handleAddCloud = () => {
    history.push('/get-started');
  };

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading
            size="xl"
            testId={PORTAL_ENDPOINTS_HEADING}
            weight="semibold"
          >
            {copy.components.endpoints.dashboard.title}
          </Heading>
          <Breadcrumb
            items={[
              {
                id: 'endpoints',
                text: copy.components.endpoints.dashboard.breadcrumb.endpoints,
              },
            ]}
          />
        </div>
        <div className="organization-dashboard-header-actions">
          <Button
            leftIcon={AddLarge}
            onClick={handleAddExisting}
            size="md"
            testId={PORTAL_ENDPOINTS_ADD_EXISTING}
            variant="tertiary-accent"
          >
            {copy.components.endpoints.dashboard.addExisting}
          </Button>
          <Button
            leftIcon={Cloud}
            onClick={handleAddCloud}
            size="md"
            testId={PORTAL_ENDPOINTS_ADD_CLOUD}
            variant="tertiary-accent"
          >
            {copy.components.endpoints.dashboard.addCloud}
          </Button>
        </div>
      </div>

      <PortalEndpointTable />
    </div>
  );
};
